import BackboneElement from './BackboneElement';
import CodeableConcept from './types/CodeableConcept';
import merge from 'lodash/merge';
import Annotation from '@/fhirworks/types/Annotation';

export default class FamilyMemberHistoryCondition extends BackboneElement {
    static __className = 'FamilyMemberHistoryCondition';

    __objectStructure = {
        code: CodeableConcept,
        note: [Annotation],
    };

    __objectDefaults = {
        status: 'draft',
    };

    constructor(constructJson, className = 'FamilyMemberHistoryCondition') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
